import React, { useState } from 'react'
import { useSearchParams } from 'react-router-dom';


import ProductListing from '../../resources/funtions/productListing'
import ProductFiltering from '../../resources/funtions/productFiltering'

const ShopSection = () => {

    let [active, setActive] = useState(false)
    let sidebarController = () => {
        setActive(!active)
    }

    const [searchParams] = useSearchParams();
    const search = searchParams.get('search') || '';

    const [quantity, setQuantity] = useState(1);
    const [filters, setFilters] = useState(null); 





    return (
        <section className="shop py-80">
            <div className={`side-overlay ${active && "show"}`}></div>
            <div className="container container-lg">
                <div className="row">
                    {/* Sidebar Start */}
                    <ProductFiltering onApplyFilters={setFilters} setQuantity={setQuantity} sidebarController={sidebarController} active = {active}/>  
                    {/* Sidebar End */}
                    {/* Content Start */}
                    <div className="col-lg-9">

                        <ProductListing quantity={quantity} filters={filters} search={search} sidebarController={sidebarController}/>
                    </div>
                    {/* Content End */}
                </div>
            </div>
        </section>

    )
}

export default ShopSection